module.exports = fox._r("images/press/materials-icon-ban.png", __webpack_public_path__ + "_/common/images/press/materials-icon-ban.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/materials-icon-ban.png
// module id = 369
// module chunks = 2